export const LunarMark = ({ size = 34, className = "", ...rest }) => (
    <img
        src="/assets/lunar-icon.png"
        alt=""
        aria-hidden="true"
        className={`object-contain ${className}`}
        style={{ height: size, width: "auto" }}
        {...rest}
    />
);

export const Logo = ({ size = 34, variant = "dark", className = "", ...rest }) => (
    <img
        src={variant === "light" ? "/assets/lunar-logo-light.png" : "/assets/lunar-logo.png"}
        alt="Lunar"
        className={`object-contain ${className}`}
        style={{ height: size, width: "auto" }}
        {...rest}
    />
);
